import { compose, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';

import {
  loggedUserIdSelector,
  targetUserIdSelector,
} from '../../redux/context/selectors';
import {
  selectUpcomingSurvey,
  selectUpcomingSurveyProceedRejected,
} from '../../redux/surveys/selectors';
import { actions as upcomingSurveyActions } from '../../redux/surveys/upcoming-survey';
import { actions as upcomingSurveyProceedActions } from '../../redux/surveys/upcoming-survey-proceed';
import { actions as upcomingSurveyAnswersActions } from '../../redux/surveys/upcoming-survey-answers';
import { actions as upcomingSurveyCancelFillingActions } from '../../redux/surveys/upcoming-survey-cancel-filling';
import styles from './index.styl';

const mapStateToProps = (state, { targetUserId }) => ({
  targetUserId:
    targetUserId || targetUserIdSelector(state) || loggedUserIdSelector(state),
  upcomingSurvey: selectUpcomingSurvey(state),
  isUpcomingSurveyRejected: selectUpcomingSurveyProceedRejected(state),
});

const mapDispatchToProps = {
  sendUpcomingSurveyProceed: upcomingSurveyProceedActions.send,
  sendUpcomingSurveyAnswers: upcomingSurveyAnswersActions.send,
  sendUpcomingSurveyCancelFilling: upcomingSurveyCancelFillingActions.send,
  clearUpcomingSurvey: upcomingSurveyActions.clear,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ intl: { formatMessage } }) => ({ formatMessage })),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/SequentialSurveyPopup/enhance.js